import { render, staticRenderFns } from "./SceneryTab.vue?vue&type=template&id=0d19e668&scoped=true&"
import script from "./SceneryTab.vue?vue&type=script&lang=js&"
export * from "./SceneryTab.vue?vue&type=script&lang=js&"
import style0 from "./SceneryTab.vue?vue&type=style&index=0&id=0d19e668&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d19e668",
  null
  
)

export default component.exports